// Top spacing used to clear the fixed (absolute) header rendered by AppLayout,
// matching the offset used by other top-level screens (e.g. PathContent).
export const HEADER_CONTENT_TOP_SPACING = 50
